<template>
  <div class="create-task">
    <div class="create-task-header">
      <h3 class="create-task-title">创建发放任务</h3>
      <div class="create-task-actions">
        <el-button size="small" @click="goBack">返回页面</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="handleCreate">创建任务</el-button>
      </div>
    </div>

    <GlobalChunk>
      <el-form
        :model="form"
        :rules="rules"
        ref="createForm"
        label-width="90px"
        class="create-form"
      >
        <el-form-item label="任务标题" prop="taskName">
          <el-input
            v-model.trim="form.taskName"
            placeholder="请填写本次任务标题，例如6月补充绩效发放"
            maxlength="20"
            show-word-limit
            clearable
          />
        </el-form-item>
      </el-form>

      <div class="import-section">
        <el-button size="small" type="primary" @click="importDialogVisible = true">导入发放明细</el-button>
      </div>

      <!-- 导入发放明细弹窗 -->
      <el-dialog
        title="导入发放明细"
        :visible.sync="importDialogVisible"
        :close-on-click-modal="false"
        width="500px"
        @closed="handleImportDialogClosed"
      >
        <div class="import-dialog-tip">说明：首次建议先下载职员数据，填写奖励明细后导入</div>
        <div class="import-dialog-btns">
          <el-button type="success" icon="el-icon-download" size="medium" @click="downloadTemplate">下载数据模板</el-button>
          <el-button icon="el-icon-download" size="medium" :loading="staffDownloadLoading" @click="downloadStaffData">下载企业职员数据</el-button>
        </div>
        <el-form ref="importForm" :model="importForm" :rules="importRules" label-width="80px">
          <el-form-item label="表格上传" prop="fileName" class="fileName">
            <div class="upload-row">
              <el-input v-model="importForm.fileName" :disabled="true" size="medium" clearable @clear="fileClear" />
              <div class="upload-btn-wrap">
                <el-button size="medium" type="warning" icon="el-icon-upload2">上传表格</el-button>
                <input
                  ref="fileUpload"
                  accept=".xls, .xlsx"
                  type="file"
                  class="file-input"
                  @change="onUploadList"
                />
              </div>
            </div>
            <div class="upload-limit">仅支持.xls及.xlsx格式，单次上传大小不超过5M</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="importLoading" @click="uploadFile">确定</el-button>
        </span>
      </el-dialog>

      <GlobalTable
        v-if="refresh"
        ref="detailTable"
        :columns="tableColumns"
        :data="slicedDetailList"
        :currentPage="page.pageNum"
        :total="page.total"
        @handleCurrentChange="handleCurrentChange"
      >
        <el-table-column label="操作" slot="operation" align="center" width="80px">
          <template slot-scope="{ $index }">
            <el-button size="mini" type="text" style="color: #f56c6c;" @click="handleDelete($index)">删除</el-button>
          </template>
        </el-table-column>
      </GlobalTable>

      <div class="statistics">
        <span>本次导入数据：<b>{{ detailList.length }}</b>条</span>
        <span>发放总金额：<b>{{ totalAmount }}</b>元</span>
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "CreateTask",
  data() {
    return {
      refresh: true,
      submitLoading: false,
      form: {
        taskName: "",
      },
      rules: {
        taskName: [{ required: true, message: "请输入任务标题", trigger: "blur" }],
      },
      importDialogVisible: false,
      importForm: {
        fileName: "",
      },
      importRules: {
        fileName: [{
          required: true,
          message: "请上传表格",
          trigger: "blur",
        }],
      },
      importLoading: false,
      staffDownloadLoading: false,
      paramsExcel: {},
      detailList: [],
      tableColumns: [
        { label: "序号", type: "index", width: "60px" },
        { label: "员工ID", prop: "staffId" },
        { label: "岗位", prop: "staffType" },
        { label: "所在门店", prop: "storeName" },
        { label: "姓名", prop: "staffName" },
        { label: "手机号", prop: "mobile" },
        { label: "发放绩效", prop: "performanceDesc" },
        { slotName: "operation" },
      ],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    slicedDetailList() {
      const start = (this.page.pageNum - 1) * this.page.pageSize;
      const end = start + this.page.pageSize;
      return this.detailList.slice(start, end);
    },
    totalAmount() {
      return this.detailList.reduce((sum, item) => sum + (Number(item.performance) || 0), 0);
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
    },
    handleImportDialogClosed() {
      this.importForm.fileName = "";
      this.paramsExcel = {};
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.value = "";
      }
      this.$refs.importForm && this.$refs.importForm.resetFields();
    },
    downloadTemplate() {
      const link = document.createElement("a");
      link.href = "/static/导入发放绩效模板.xlsx";
      link.setAttribute("download", "导入发放绩效模板.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadStaffData() {
      this.staffDownloadLoading = true;
      _api.excelPerformanceStaff().then((res) => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "企业职员数据.xlsx";
        link.click();
        URL.revokeObjectURL(url);
      }).finally(() => {
        this.staffDownloadLoading = false;
      });
    },
    onUploadList(event) {
      this.paramsExcel.file = event.target.files;
       const maxSize = 5 * 1024 * 1024; // 5MB
       console.log(this.paramsExcel.file[0].size,'jAHDKJGDJK999');
      if (this.paramsExcel.file[0].size > maxSize) {
        this.$message.error('上传文件不能超过 5MB！');
        this.$refs.fileUpload.value = '';
        return;
      }
      if (this.paramsExcel.file.length) {
        this.paramsExcel.excelName = event.target.files[0].name;
        this.importForm.fileName = event.target.files[0].name;
      }
    },
    uploadFile() {
      this.$refs.importForm.validate((valid) => {
        if (!valid) return;
        if (!this.paramsExcel.file || this.paramsExcel.file.length === 0) {
          return this.$message.error("请上传表格");
        }
        this.importLoading = true;
        const fd = new FormData();
        fd.append("file", this.paramsExcel.file[0]);
        _api.parseImportPerformanceExcel(fd).then((res) => {
          const data = res.data || {};
          const details = data.details || [];
          this.detailList = details.map((item) => ({
            ...item,
            performanceDesc: (item.performance || 0) + "元",
          }));
          this.page.pageNum = 1;
          this.page.total = this.detailList.length;
          this.$message.success("导入成功，共" + (data.totalCount || 0) + "条");
          this.importDialogVisible = false;
        }).finally(() => {
          this.importLoading = false;
        });
      });
    },
    fileClear() {
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
    },
    handleDelete(index) {
      const realIndex = (this.page.pageNum - 1) * this.page.pageSize + index;
      this.detailList.splice(realIndex, 1);
      this.page.total = this.detailList.length;
      const maxPage = Math.ceil(this.page.total / this.page.pageSize) || 1;
      if (this.page.pageNum > maxPage) {
        this.page.pageNum = maxPage;
      }
    },
    handleCreate() {
      this.$refs.createForm.validate((valid) => {
        if (!valid) return;
        if (this.detailList.length === 0) {
          return this.$message.error("发放明细不可为空");
        }
        this.submitLoading = true;
        const params = {
          taskName: this.form.taskName,
          details: this.detailList.map((item) => ({
            staffId: item.staffId,
            performance: item.performance,
          })),
        };
        _api.createPerformanceTask(params).then(() => {
          this.$message.success("创建成功");
          this.goBack();
        }).finally(() => {
          this.submitLoading = false;
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.create-task {
  .create-task-header {
    padding: 10px 20px;
    background: #FFFFFF;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .create-task-title {
      font-size: 18px;
      font-weight: 700;
      color: #242D3E;
      margin: 0;
    }

    .create-task-actions {
      display: flex;
      gap: 10px;
    }
  }

  .create-form {
    margin-bottom: 20px;

    .el-input {
      width: 500px;
    }
  }

  .import-section {
    margin-bottom: 20px;
  }

  .statistics {
    margin-top: 20px;
    font-size: 14px;
    color: #666;

    span {
      margin-right: 40px;
    }

    b {
      color: #0981ff;
      margin: 0 4px;
    }
  }

  .import-dialog-tip {
    color: #ff687b;
    margin-bottom: 18px;
  }

  .import-dialog-btns {
    margin-bottom: 20px;

    .el-button + .el-button {
      margin-left: 10px;
    }
  }

  .fileName {
    /deep/.el-input {
      width: 260px;
    }

    .upload-row {
      display: flex;
      align-items: center;
    }

    .upload-btn-wrap {
      display: flex;
      align-items: center;
      position: relative;
      margin-left: 10px;
      vertical-align: top;

      .file-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }

    .upload-limit {
      color: #ff687b;
      margin-top: 8px;
    }
  }
}
</style>
